import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { MyTrainerSessions } from "@/features/trainer/MyTrainerSessions";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";

export const Route = createFileRoute("/_app/my-sessions")({
  // A trainer's sessions are hidden while the ilt flag is off (the API 404s them too).
  beforeLoad: async () => {
    const { ilt } = await fetchFeatureFlags();
    if (!ilt) throw redirect({ to: "/my-learning" });
  },
  component: MySessionsRoute,
});

/** My sessions (LMS-203): the sessions a trainer is assigned to deliver. Only for trainers. */
function MySessionsRoute() {
  return (
    <ProtectedRoute
      requiredPermissions={["IltSessions.Deliver"]}
      requiredRoles={["Trainer"]}
      redirectTo="/my-learning"
    >
      <MyTrainerSessions />
    </ProtectedRoute>
  );
}
